import { inject, Injectable } from '@angular/core';
import { from, map, switchMap, take } from 'rxjs';
import { CheckoutDialogComponent } from '../account/dialogs/checkout-dialog/checkout-dialog.component';
import { FeaturePaywallDialogComponent } from '../account/dialogs/feature-paywall-dialog/feature-paywall-dialog.component';
import { BillingScope } from '../billing-consts';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';
import { DialogService } from './dialog.service';
import { PermissionService } from './permission.service';
import { ProductService } from './product.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class CheckoutService {
  private dialog = inject(DialogService);
  private productService = inject(ProductService);
  private permissionService = inject(PermissionService);
  private storyblokService = inject(PICFLOW_STORYBLOK);
  private toastService = inject(ToastService);

  open(scope: BillingScope) {
    if (!this.permissionService.shouldRedirectToPricingPage()) {
      this.toastService.add('Ask an Admin to upgrade to use this feature', 'error');
      return;
    }

    this.storyblokService
      .getStories({
        content_type: 'UpgradeFeature',
        filter_query: [{ key: 'scope', value: scope }],
      })
      .pipe(take(1))
      .subscribe(stories => {
        const story = stories[0];

        if (!story) {
          this.permissionService
            .getMinPlanForScope(scope)
            .pipe(
              switchMap(productName => {
                return from(this.productService.getAllProducts()).pipe(
                  take(1),
                  map(products => products.find(product => product.name.toLowerCase() === productName))
                );
              })
            )
            .subscribe(product => this.dialog.open(CheckoutDialogComponent, { product }));
        } else {
          this.dialog.open(FeaturePaywallDialogComponent, { content: story.content });
        }
      });
  }
}
